import { defineMessages } from "react-intl";

export const wizardMessages = defineMessages({
  wizardTitle: {
    defaultMessage: "Add domains and partitions",
    id: "wizard-messages.wizardTitle",
  },

  adConnectorDownLoad: {
    defaultMessage: "Download AD connector",
    id: "wizard-messages.adConnectorDownLoad",
  },

  adConnectorDownLoadInfo: {
    defaultMessage:
      "No AD connector is currently configured. Install Cayosoft Guardian AD Connector on a domain-joined server in your on-premises Active Directory forest. The server must have network access to at least one domain controller. {link}.",
    id: "wizard-messages.adConnectorDownLoadInfo",
  },

  adConnectorDownLoadButtonTitle: {
    defaultMessage: "Download AD connector and install it on your on-prem machine",
    id: "wizard-messages.adConnectorDownLoadButtonTitle",
  },

  download: {
    defaultMessage: "Download",
    id: "wizard-messages.Download",
  },

  adConnectorStepName: {
    defaultMessage: "Select connection method",
    id: "wizard-messages.adConnectorStepName",
  },

  adConnectorCheckBox: {
    defaultMessage: "Use AD connector to manage domains",
    id: "wizard-messages.adConnectorCheckBox",
  },

  adConnectorCheckBoxTooltip: {
    defaultMessage: "Use AD connector to manage your remote Active Directory domains. {link}.",
    id: "wizard-messages.adConnectorCheckBoxTooltip",
  },

  adConnectorMessage: {
    defaultMessage:
      "AD connector allows managing remote Active Directory forests. An example of such an environment could be a Cayosoft Guardian server installed in the cloud and AD connector installed on a member server. Do not use AD connector if Cayosoft Guardian is installed on a member server in the same forest. {link}.",
    id: "wizard-messages.adConnectorMessage",
  },

  adConnectorMessageHosted: {
    defaultMessage:
      "The AD connector enables Cayosoft Guardian to manage remote Active Directory forests. The connector runs in the on-premises environment and securely connects the forest to the Cayosoft Guardian service. Note that an AD connector must be deployed and registered before using this wizard. {link}.",
    id: "wizard-messages.adConnectorMessageHosted",
  },

  connectionStepName: {
    defaultMessage: "Choose connection account type",
    id: "wizard-messages.connectionStepName",
  },

  connectionFormTitle: {
    defaultMessage: "Connection account",
    id: "wizard-messages.connectionFormTitle",
  },

  connectionGmsaOption: {
    defaultMessage: "Create new custom group Managed Service Accounts",
    id: "wizard-messages.connectionGmsaOption",
  },

  addAccountToPrivileged: {
    defaultMessage: "Cayosoft Guardian will add connection accounts to privileged groups. {link}.",
    id: "wizard-messages.addAccountToPrivileged",
  },

  connectionOption: {
    defaultMessage: "Use the credentials of an existing user account",
    id: "wizard-messages.connectionOption",
  },

  downloadAdConnectorConfigTitle: {
    defaultMessage: "Download AD connector configuration file",
    id: "wizard-messages.downloadAdConnectorConfigTitle",
  },

  downloadAdConnectorConfigButtonTitle: {
    defaultMessage: "Download AD connector configuration",
    id: "wizard-messages.downloadAdConnectorConfigButtonTitle",
  },

  adConnectorConfigInstructionsTitle: {
    defaultMessage: "Configuration file installation instructions. {link}.",
    id: "wizard-messages.adConnectorConfigInstructionsTitle",
  },

  adConnectorConfigIsInProgress: {
    defaultMessage: "To proceed, install the AD connector, then return here to complete the setup.",
    id: "wizard-messages.adConnectorConfigIsInProgress",
  },

  adConnectorConfigInstructionsLearnMore: {
    defaultMessage: "Learn more",
    id: "wizard-messages.adConnectorConfigInstructionsLearnMore",
  },

  adConnectorConfigStep1: {
    defaultMessage:
      "On your on-premises AD Connector server, launch Cayosoft Guardian AD Connector.",
    id: "wizard-messages.adConnectorConfigStep1",
  },

  adConnectorConfigStep2: {
    defaultMessage: "Sign in to Cayosoft AD Connector using local administrator credentials.",
    id: "wizard-messages.adConnectorConfigStep2",
  },

  adConnectorConfigStep3: {
    defaultMessage:
      "Go to Configuration > Guardian services, then click Connect to Guardian service.",
    id: "wizard-messages.adConnectorConfigStep3",
  },

  adConnectorConfigStep4: {
    defaultMessage:
      "Import the configuration file (download it from this step), then click Connect.",
    id: "wizard-messages.adConnectorConfigStep4",
  },

  adConnectorConfigStep5: {
    defaultMessage:
      "When the connection shows as established, return here and click Next to continue.",
    id: "wizard-messages.adConnectorConfigStep5",
  },

  specifyCredentialsMain: {
    defaultMessage: "Specify connection account",
    id: "wizard-messages.specify-credentials-main",
  },

  specifyCredentialsSubTitle: {
    defaultMessage: "Use the credentials of an existing connection account",
    id: "specifyCredentialsSubTitle",
  },

  specifyCredentialsMessage: {
    defaultMessage:
      "Create a separate account for Cayosoft Guardian and specify credentials below. We need an account with Domain Admin rights to configure a specific domain.",
    id: "specifyCredentialsMessage",
  },

  specifyCredentialsMainOne: {
    defaultMessage:
      "Provide an existing connection account credentials to add domains for Forest Recovery and Change Monitoring",
    id: "wizard-messages.specifyCredentialsMainOne",
  },

  specifyCredentialsMainTwo: {
    defaultMessage: "Create new custom connection accounts for only Change Monitoring",
    id: "wizard-messages.specifyCredentialsMainTwo",
  },

  specifyCredentialsOptionOneDesc: {
    defaultMessage:
      "Create a separate account for Cayosoft Guardian and specify credentials below. We need an account with Domain Admin rights to configure a specific domain.",
    id: "wizard-messages.specifyCredentialsOptionOneDesc",
  },

  specifyCredentialsOptionTwoDesc: {
    defaultMessage:
      "We need an account with Enterprise Admin rights to create custom connection accounts for you. {LearnMore} This account will be used only in the configuration process and will not be preserved.",
    id: "wizard-messages.specifyCredentialsOptionTwoDesc",
  },

  specifyCredentialsSub: {
    defaultMessage:
      "Enter credentials for an account with Enterprise Admin rights to configure the managed systems.",
    id: "wizard-messages.specify-credentials-sub",
  },
  specifyCredentialsLink: {
    defaultMessage: "Learn more.",
    id: "wizard-messages.specify-credentials-link",
  },

  selectDomainsAndPartitions: {
    defaultMessage: "Select domains and partitions",
    id: "wizard-messages.select-domains-and-partitions",
  },

  selectDomainsAndPartitionsSub: {
    defaultMessage:
      "Choose the domains and partitions you want to include in the configuration process.",
    id: "wizard-messages.select-domains-and-partitions-sub",
  },

  selectDomainsAndPartitionsInfo: {
    defaultMessage: "Selected partitions will be added to the product.",
    id: "wizard-messages.selectDomainsAndPartitionsInfo",
  },

  selectDomainsAndPartitionsAddedTitle: {
    defaultMessage: "Partitions to be added",
    id: "wizard-messages.selectDomainsAndPartitionsAddedTitle",
  },

  selectDomainsAndPartitionsSkipTitle: {
    defaultMessage:
      "Account {accountName} does not have permissions to configure the following partitions. If you still need to configure these partitions, enter credentials with the required permissions on the Configure connection accounts page. {LearnMore}. ",
    id: "wizard-messages.selectDomainsAndPartitionsSkipTitle",
  },

  selectDomainsAndPartitionsAddedDesc: {
    defaultMessage: "Enable partitions you want to add.",
    id: "wizard-messages.selectDomainsAndPartitionsAddedDesc",
  },

  selectDomainsAndPartitionsSkipDesc: {
    defaultMessage:
      "Account {accountName} does not have permissions to configure the following partitions. If you want the listed partitions to be enabled, run the wizard again and provide credentials. {LearnMore}.",
    id: "wizard-messages.selectDomainsAndPartitionsSkipDesc",
  },

  createConnectionAccounts: {
    defaultMessage: "Create connection accounts",
    id: "wizard-messages.createConnectionAccounts",
  },

  createConnectionAccountsSub: {
    defaultMessage: "Create new custom connection account",
    id: "wizard-messages.createConnectionAccountsSub",
  },

  createConnectionAccountsMsg: {
    defaultMessage:
      "Sign in with an account with Enterprise Admin rights to create custom connection accounts for you. {link}. This account will be used only in the configuration process and will not be preserved.",
    id: "wizard-messages.createConnectionAccountsMsg",
  },

  createConnectionAccountsMsgHosted: {
    defaultMessage:
      "Sign in with an account that has Enterprise Admin privileges to create the required connection accounts. {link}. This account is used only during the configuration process and is not stored or preserved after setup.",
    id: "wizard-messages.createConnectionAccountsMsgHosted",
  },

  createConnectionAccountsDialog: {
    defaultMessage:
      "Sign In with an account with Enterprise Admin rights to create custom connection accounts for you. This account will be used only in the configuration process and will not be preserved.",
    id: "wizard-messages.createConnectionAccountsDialog",
  },

  gmsaAdminCheckbox: {
    defaultMessage: "Add account to privileged groups to use the automatic rollback feature",
    id: "gmsaAdminCheckbox",
  },

  gmsaReadonly: {
    defaultMessage: "Configure gMSA connection accounts with read-only permissions (more secure)",
    id: "wizard-messages.gmsaReadonly",
  },

  gmsaAdmin: {
    defaultMessage:
      "For using autorollback, configure gMSA connection accounts with elevated permissions",
    id: "wizard-messages.gmsaAdmin",
  },

  userConfig: {
    defaultMessage: "Use the account {user} provided on the previous step (not recommended)",
    id: "wizard-messages.userConfig",
  },

  gmsaDescription: {
    defaultMessage:
      "Cayosoft Guardian will create connection accounts in the selected domains and make other changes. Learn more about Cayosoft Guardian {link}",
    id: "wizard-messages.gmsaDescription",
  },

  gmsaDescriptionLink: {
    defaultMessage: "custom connection accounts.",
    id: "wizard-messages.gmsaDescriptionLink",
  },

  monitoringAudit: {
    defaultMessage: "Change monitoring options",
    id: "wizard-messages.monitoringAudit",
  },

  monitoringAuditDescription: {
    defaultMessage:
      "To detect who performed changes, Cayosoft Guardian enables native event logging for modifications in your partitions.",
    id: "wizard-messages.monitoringAuditDescription",
  },

  monitoringAuditDescriptionLink: {
    defaultMessage:
      "Learn more about Active Directory audit event collection in Cayosoft Guardian.",
    id: "wizard-messages.monitoringAuditDescriptionLink",
  },

  managedDomainsAndPartitions: {
    defaultMessage: "Managed domains and partitions",
    id: "wizard-messages.managedDomainsAndPartitions",
  },

  closeConfirmation: {
    defaultMessage: "Domains and Partitions registration is incomplete.",
    id: "new-partition-wizard.close-confirmation",
  },

  creationManaged: {
    defaultMessage: "The following partitions will now appear in your list of managed systems.",
    id: "new-partition-wizard.creationManaged",
  },

  creationError: {
    defaultMessage: "The following partitions were not properly configured.",
    id: "new-partition-wizard.creationError",
  },

  creationErrorLink: {
    defaultMessage: "Learn more.",
    id: "new-partition-wizard.creationErrorLink",
  },

  jobsTitle: {
    defaultMessage: "Configured jobs",
    id: "new-partition-wizard.jobsTitle",
  },

  jobsTitleToggle: {
    defaultMessage:
      "By default, change collection starts immediately on the successful completion of the wizard. However, you can stop jobs to prevent changes from being collected.",
    id: "new-partition-wizard.jobsTitleToggle",
  },

  auditingToggle: {
    defaultMessage: "Enable auditing for selected domains to track and identify changes.",
    id: "new-partition-wizard.auditingToggle",
  },

  LearnMore: {
    defaultMessage: "Learn more",
    id: "new-partition-wizard.LeanMore",
  },

  maxAccountNameLength: {
    defaultMessage:
      "Managed service account name must not be longer than {maxAccountNameLength} characters.",
    id: "new-partition-wizard.maxAccountNameLength",
  },

  invalidChars: {
    defaultMessage: 'Account name contains invalid characters: " / \\ [ ] : ; | = , + * ? < >',
    id: "new-partition-wizard.invalidChars",
  },

  validAccountName: {
    defaultMessage: "Account name is valid.",
    id: "new-partition-wizard.validAccountName",
  },

  fieldForestName: {
    defaultMessage: "Forest name",
    id: "new-partition-wizard.fieldForestName",
  },

  fieldForestNamePlaceholder: {
    defaultMessage: "Enter the forest name (e.g. corp.example.com)",
    id: "new-partition-wizard.fieldForestNamePlaceholder",
  },

  fieldAccountName: {
    defaultMessage: "Account name",
    id: "new-partition-wizard.fieldAccountName",
  },

  gmsaFieldAccountName: {
    defaultMessage: "Specify a name for gMSA to be created",
    id: "new-partition-wizard.gmsafieldAccountName",
  },

  gmsaFieldAccountNameTooltip: {
    defaultMessage:
      "Cayosoft Guardian creates a group Managed Service Account gMSA in each selected domain using the specified value and a random suffix.",
    id: "new-partition-wizard.gmsaFieldAccountNameTooltip",
  },

  fieldAccountNamePlaceholder: {
    defaultMessage: "Enter the account name (e.g., user@example.com)",
    id: "new-partition-wizard.fieldAccountNamePlaceholder",
  },

  fieldPassword: {
    defaultMessage: "Password",
    id: "new-partition-wizard.fieldPassword",
  },

  fieldPasswordPlaceholder: {
    defaultMessage: "Enter your password",
    id: "new-partition-wizard.fieldPasswordPlaceholder",
  },

  adConnector: {
    defaultMessage: "AD connector",
    id: "new-partition-wizard.adConnector",
  },

  adConnectorPlaceholder: {
    defaultMessage: "Select AD connector",
    id: "new-partition-wizard.adConnectorPlaceholder",
  },

  auditSwitch: {
    defaultMessage: "Detect who performed changes",
    id: "new-partition-wizard.auditSwitch",
  },

  collectionSwitch: {
    defaultMessage: "Start change collection immediately",
    id: "new-partition-wizard.collectionSwitch",
  },

  goToAd: {
    defaultMessage: "Go to AD connectors",
    id: "new-partition-wizard.goToAd",
  },

  signIn: {
    defaultMessage: "Sign In",
    id: "new-partition-wizard.signIn",
  },
});
